import { useEffect, useState } from 'react';
import { NudosGenericModal, NudosModalContent } from '../../../../../../components/NudosComponents';
import { getConfigClass } from '../../../../../../utils/configurations';
import useConfigurationGlobalState from '../configurationGlobalState';
import { IorganizationBusinessData } from '../../../../../../types/bussines';
import BordOneToneIcon from '../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import ConfigFieldsForm from '../../../../../../components/ToolConfigurationsSection/Components/AddSettingsModal/ConfigFieldsForm/ConfigFieldsForm';
import './ReviewConfigModal.scss';

const ReviewConfigModal = ({
  organizationData,
  closeModalCallback
}: {
  organizationData: IorganizationBusinessData;
  closeModalCallback: () => void;
}) => {
  const { configUnit } = useConfigurationGlobalState();

  const [formValues, setFormValues] = useState<Record<number, string | File>>({});

  const selectedConfigClass = getConfigClass(configUnit?.configClassId);

  useEffect(() => {
    if (configUnit?.configData) {
      const autoFillValues: Record<number, string | File> = {};
      configUnit.configData.forEach(dataItem => {
        autoFillValues[dataItem.fieldName.id] = dataItem.fieldValue;
      });
      setFormValues(autoFillValues);
    }
  }, []);

  return (
    <NudosGenericModal
      customClassName="reviewConfigModal"
      closeModalCallback={closeModalCallback}
      modalContent={
        <NudosModalContent
          customHeaderClass="mr-8"
          customWidth="580px"
          customHeight="426px"
          modalContentTitle="Configuración guardada"
          toCloseModal={closeModalCallback}
          CustomModalComponent={
            <div className="reviewConfigModalContent">
              <div className="reviewConfigModalText">
                Estás consultando una configuración de la empresa {organizationData?.businessName}
              </div>

              <div className="reviewConfigModalFieldsContainer">
                <div className="allInfoContainer">
                  <div className="infoLeftContainer">
                    <div>Tipo:</div>
                    <div>Configuración:</div>
                    <div>Herramientas:</div>
                  </div>

                  <div className="infoRightContainer">
                    <div className="flex items-center gap-4">
                      <BordOneToneIcon variant={selectedConfigClass?.variantIcon ?? 'add'} standardSize={16} />
                      <span className="dataText">{selectedConfigClass?.name}</span>
                    </div>
                    <div className="dataText">{configUnit?.name}</div>
                    <div className="dataText">{`${configUnit?.tools?.length} Unidades`}</div>
                  </div>
                </div>

                <div className="mt-24">
                  {selectedConfigClass && (
                    <ConfigFieldsForm
                      selectedConfigClass={selectedConfigClass}
                      isDisabled
                      formValues={formValues}
                      setFormValues={() => {}}
                      setIsFormValid={() => {}}
                      showAlert={false}
                    />
                  )}
                </div>
              </div>
            </div>
          }
        />
      }
    />
  );
};

export default ReviewConfigModal;
